import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-infobulle',
    templateUrl: './infobulle.component.html',
    styleUrls: ['./infobulle.component.scss'],
})
export class InfobulleComponent {
    @Input() public text: string;
    @Input() public icon?: string;
    public displayContent: boolean;

    public onHover(): void {
        this.displayContent = true;
    }

    public onHoverOut(): void {
        this.displayContent = false;
    }
}
